<template>
  <b-row>
    <b-col cols="12">
      <b-form @submit.prevent>
        <b-form-group label="انتخاب درس مورد نظر" label-for="lesson-picker">
          <v-select
            @search="handleSearch"
            @open="onOpen"
            @close="onClose"
            :disabled="isDisabled"
            id="lesson-picker"
            dir="rtl"
            :filterable="false"
            v-if="lessonsList"
            :reduce="(lesson) => lesson"
            v-model="selectedLesson"
            :options="lessonsList"
            label="title"
            placeholder="درس را انتخاب کنید"
          >
            <template #no-options>هیچ درسی جهت نمایش وجود ندارد</template>
            <template #list-footer>
              <li v-show="hasNextPage" ref="load" class="loader">
                در حال لود...
              </li>
            </template>
          </v-select>
        </b-form-group>
      </b-form>
    </b-col>
  </b-row>
</template>
<script>
import { BRow, BCol, BForm, BFormGroup } from "bootstrap-vue";
import vSelect from "vue-select";
import { GetAllLessonsV2 as GetAllLessons } from "@/libs/Api/Lesson";

export default {
  emits: ["getLesson"],
  props: {
    defaultCourseId: {
      type: [Number, String],
      required: false,
      default: null,
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mounted() {
    this.getAllLessons();
    this.observer = new IntersectionObserver(this.infiniteScroll);
  },
  watch: {
    selectedLesson: {
      handler(val) {
        this.$emit("getLesson", val ? val.lessonId : val);
      },
    },
    defaultCourseId: {
      handler(val) {
        if (val && val != "" && val != 0) {
          this.getAllLessons();
        }
      },
    },
    pageNumber: {
      handler(val) {
        this.getAllLessons(true);
      },
    },
  },
  data() {
    return {
      lessonsList: [],
      totalCount: null,
      selectedLesson: null,
      searchVal: null,
      timeout: null,
      observer: null,
      count: 30,
      pageNumber: 1,
    };
  },
  methods: {
    clearSelectedLesson() {
      this.selectedLesson = null;
    },
    handleSearch(searchValue, loadingFn) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(async () => {
        this.searchVal = searchValue;
        loadingFn(true);
        await this.getAllLessons();
        loadingFn(false);
      }, 300);
    },
    async infiniteScroll([{ isIntersecting, target }]) {
      if (isIntersecting) {
        if (this.hasNextPage) {
          this.pageNumber++;
        }
      }
    },
    async onOpen() {
      if (this.hasNextPage) {
        await this.$nextTick();
        this.observer.observe(this.$refs.load);
      }
    },
    onClose() {
      this.observer.disconnect();
    },
    async getAllLessons(isLoadMore = false) {
      try {
        let reqParams = {
          count: this.count,
          pageNumber: this.pageNumber,
        };
        if (this.searchVal && this.searchVal != "") {
          reqParams["searchCommand"] = this.searchVal;
        }
        let _this = this;
        let getAllLessons = new GetAllLessons(_this);
        getAllLessons.setRequestParam(reqParams);
        await getAllLessons.fetch(function (response) {
          if (response.isSuccess) {
            if (isLoadMore) {
              _this.lessonsList.push(...response.data.data);
            } else {
              _this.lessonsList = response.data.data;
            }
            _this.totalCount = response.data.totalCount;
          }
        });
      } catch (error) {
        console.error(error);
      }
    },
  },
  computed: {
    hasNextPage() {
      if (this.lessonsList && this.lessonsList.length < this.totalCount) {
        return true;
      }
      return false;
    },
  },
  components: {
    vSelect,
    BRow,
    BCol,
    BForm,
    BFormGroup,
  },
};
</script>
